const Footer = ()=> {

    return (      
    <footer className="app-footer">
    <p>Aric Gilinsky ©2023</p>
    <ul className="header-footer-links">
        <a className="header-footer-buttons" href="http://asgili.github.io">About Me</a>
        <a className="header-footer-buttons" href="http://github.com/ASGili">My GitHub</a>
    </ul>
    </footer>
    )
}

export default Footer;